// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1e5Ny","rootSmall":"AddTileButton_rootSmall__1cu22"};